module.exports = __webpack_public_path__ + "static/media/logo-Kauniainen.5fb7c0cf.png";